import { Component, OnInit } from '@angular/core';
import { ProgrammeService } from 'src/app/services/programme.service';
import { forkJoin } from 'rxjs';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-training-programmes',
  templateUrl: './training-programmes.component.html',
  styleUrls: ['./training-programmes.component.scss']
})
export class TrainingProgrammesComponent implements OnInit {
  public myProgrammes:any[];
  public currentTrainingProgramme:number;
  public activeProgrammeData:any;
  public loadingData=true;
  public breadcrumbLinks=[];
  public thisPage:string='Your Training Programmes';
  public programmeId:number;

  public popularSlideConfig = {
    "slidesToShow": 4,
    "slidesToScroll": 4,
    'arrows': true,
    autoplay: false,
    'responsive': [
      {'breakpoint': 1299, 'settings': { 'slidesToShow': 3, 'slidesToScroll': 3, 'arrows': true} },
      {'breakpoint': 900, 'settings': { 'slidesToShow': 2, 'slidesToScroll': 2, 'arrows': false} },
      {'breakpoint': 600, 'settings': { 'slidesToShow': 1, 'slidesToScroll': 1, 'arrows': false} },
    ]};

  constructor(
    private _programmes: ProgrammeService,
    private route: ActivatedRoute
  ) {
    this.route.params.subscribe(res=>{
      if(res.id) this.programmeId=parseInt(res.id);
    });
  }

  ngOnInit() {
    forkJoin(
      this._programmes.getMyProgrammes(true)
    ).subscribe(data=>{
      this.myProgrammes=data[0];
      this.structureMyProgrammes();
      if(this.myProgrammes[0]) {
        this.currentTrainingProgramme=parseInt(this.myProgrammes[0].id) || 0;
      }
      if(this.programmeId) this.currentTrainingProgramme=this.programmeId;

      this.setActiveProgrammeData(this.currentTrainingProgramme);
      this.loadingData=false;

    });
  }

  private checkForId(){

  }

  private structureMyProgrammes(){
    this.myProgrammes.forEach((data, index) => {
      data.courses.forEach((data2, index2) => {
        this.myProgrammes[index].courses[index2]=data2.course;
      })
    });
  }

  public updateActiveProgramme(id:number){
    this.setActiveProgrammeData(id);
    this.currentTrainingProgramme=id;
  }

  public setActiveProgrammeData(id:number){
    this.myProgrammes.forEach(data => {
      if(data.id==id) this.activeProgrammeData=data;
    });
  }

}
